import Model from 'models/Model';
import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import ProductDocument from 'models/productManagement/productDocument/Model.ProductDocument';
import Dealer from '../dealer/Model.Dealer';
import { Language } from 'assets/locales/Locale';

export default class ProductDealerDocument
  extends Model<Model.IProductDealerDocument>({ icon: 'if-login' })
  implements Model.Instance<Model.IProductDealerDocument>
{
  id: number;
  productDocumentId: number;
  productDocument?: ProductDocument;
  dealerId: number;
  dealer?: Dealer;
  mediaFileId: number;
  mediaFile: MediaFile;
  languageIsoCode?: Locale.Languages = Language.english;

  constructor(
    data: Partial<Model.IProductDealerDocument> | Utils.FormData<Model.IProductDealerDocument>,
    language?: Locale.Languages
  ) {
    super(
      {
        mediaFile: MediaFile,
        productDocument: ProductDocument,
        dealer: Dealer,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.mediaFile?.name || this.id?.toString(),
    };
  }
}
